export {}

export const HOVER_COLORS = {
    fenrir_dark: '#1C1C20',
    ferir_nut: '#F0A471',
    fenrir_sky: '#5EC2EB',
    fenrir_cotton: '#EEF7FF',
    fenrir_mythic: '#A25EFA'
}